function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "20.918 355.38 255.97 491.12 491.08 355.38 256.18 219.76",
  fill: "#E0E0E2"
});

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "491.08 355.38 491.08 376.26 255.97 512 255.97 491.12",
  fill: "#C6C5CB"
});

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "20.918 355.38 20.918 376.26 255.97 512 255.97 491.12",
  fill: "#D8D8DA"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "255.97 470.24 454.92 355.38 454.92 209.21 255.97 324.06",
  fill: "#ACABB1"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "57.084 209.21 57.084 355.38 255.97 470.24 255.97 324.06",
  fill: "#C6C5CB"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "39 198.77 39 219.65 255.97 344.95 473 219.65 473 198.77 256 73.487",
  fill: "#D8D8DA"
});

var _ref8 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "39 198.77 255.97 324.06 473 198.77 256 73.487",
  fill: "#E0E0E2"
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "75.167 198.77 255.97 303.19 436.83 198.77 256 94.368",
  fill: "#898890"
});

var _ref10 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "93.236 209.22 255.97 115.23 256 94.368 75.167 198.77",
  fill: "#C6C5CB"
});

var _ref11 =
/*#__PURE__*/
React.createElement("polyline", {
  points: "436.83 198.77 418.74 209.22 255.97 115.23 256 94.368",
  fill: "#D8D8DA"
});

var _ref12 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "201.73 459.76 201.72 313.6 93.251 250.58 93.251 396.73 111.33 407.17 111.32 282.29 183.65 324.04 183.65 449.32",
  fill: "#00AB95"
});

var _ref13 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#008778"
}, React.createElement("polygon", {
  points: "201.72 313.63 201.75 459.78 219.81 449.35 219.81 324.04"
}), React.createElement("polygon", {
  points: "111.33 407.17 129.42 396.74 129.42 292.74 111.32 282.29"
}));

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "m169.33 369.99c5e-3 -20.873-5.914-41.232-13.155-45.242-7.24-4.01-13.164 9.785-13.164 30.658v49.075l26.329 15.226-0.01-49.717z",
  fill: "#00AB95"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "m166.71 378.21c4e-3 -16.715-4.736-33.019-10.535-36.231s-10.542 7.837-10.542 24.553v39.301l21.085 12.194-8e-3 -39.817z",
  fill: "#01CDB4"
});

var _ref16 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#2487FF"
}, React.createElement("path", {
  d: "m246.96 369.95v32.196l-18.439-10.445 0.018-30.039c3e-3 -5.16 5.544-8.421 10.056-5.917 5.163 2.863 8.365 8.302 8.365 14.205z"
}), React.createElement("path", {
  d: "m84.215 275.99v32.196l-18.439-10.445 0.018-30.039c3e-3 -5.16 5.544-8.421 10.056-5.917 5.163 2.863 8.365 8.301 8.365 14.205z"
}), React.createElement("path", {
  d: "m274.08 364.94v32.196l18.439-10.644-0.018-29.841c-3e-3 -5.16-5.544-8.421-10.056-5.917-5.162 2.864-8.365 8.303-8.365 14.206z"
}), React.createElement("path", {
  d: "m310.25 344.06v32.196l18.439-10.643-0.018-29.841c-3e-3 -5.16-5.544-8.421-10.056-5.917-5.163 2.862-8.365 8.302-8.365 14.205z"
}), React.createElement("path", {
  d: "m346.42 323.18v32.196l18.439-10.64-0.018-29.845c-3e-3 -5.16-5.544-8.421-10.056-5.917-5.162 2.863-8.365 8.303-8.365 14.206z"
}), React.createElement("path", {
  d: "m382.58 302.3v32.196l18.439-10.642-0.018-29.843c-3e-3 -5.16-5.544-8.421-10.056-5.917-5.163 2.863-8.365 8.303-8.365 14.206z"
}), React.createElement("path", {
  d: "m418.75 281.42v32.196l18.439-10.639-0.018-29.846c-3e-3 -5.16-5.544-8.421-10.056-5.917-5.162 2.864-8.365 8.303-8.365 14.206z"
}));

var _ref17 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "116.79 410.77 107.7 415.77 161.87 447.2 170.85 441.99",
  fill: "#E0E0E2"
});

var _ref18 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "107.7 415.77 107.7 426.26 161.85 457.52 161.87 447.2",
  fill: "#C6C5CB"
});

var _ref19 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "107.78 426.37 98.686 431.37 152.85 462.8 161.84 457.59",
  fill: "#E0E0E2"
});

var _ref20 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "98.686 431.37 98.686 441.94 152.84 473.21 152.85 462.8",
  fill: "#C6C5CB"
});

var _ref21 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "161.87 447.2 161.86 457.59 152.85 462.8 152.84 473.21 161.84 468 161.85 467.91 161.85 468.01 170.85 462.8 170.85 441.99",
  fill: "#ACABB1"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "m369.05 152.87v-0.068h-2e-3c0.139-16.621-10.68-33.232-32.505-45.834-43.725-25.245-115.76-25.245-160.08 0-22.174 12.632-33.361 29.292-33.522 45.954v51.568c-0.166 16.641 10.669 33.285 32.549 45.917 43.781 25.277 115.82 25.277 160.08 0 22.12-12.633 33.294-29.276 33.48-45.917h1e-3v-0.015c-1e-3 -6e-3 -1e-3 -51.596-1e-3 -51.605z",
  fill: "#C6C5CB"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "m175.5 198.82c-43.781-25.277-43.343-66.612 0.974-91.858s116.35-25.245 160.08 0 43.287 66.581-0.974 91.858-116.3 25.276-160.08 0z",
  fill: "#E0E0E2"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "m354.88 150.95c-0.054 14.647-9.838 29.313-29.295 40.416-38.716 22.116-101.74 22.116-140.04 0-18.825-10.868-28.301-25.118-28.463-39.44-0.018-0.253-0.018-0.507-0.018-0.742 0-54.612 44.286-98.897 98.916-98.897 54.358 0 98.481 43.87 98.879 98.12 0.018 0.181 0.018 0.362 0.018 0.543z",
  fill: "#00AB95"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "m324.64 134.76c-0.042 11.291-7.583 22.595-22.581 31.153-29.843 17.047-78.421 17.047-107.94 0-14.51-8.377-21.814-19.362-21.939-30.401-0.014-0.195-0.014-0.391-0.014-0.572 0-42.095 34.136-76.232 76.246-76.232 41.901 0 75.912 33.816 76.218 75.633 0.013 0.141 0.013 0.28 0.013 0.419z",
  fill: "#01CDB4"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "m256 28.031l-4.649 35.71c-7e-3 0.684 0.439 1.369 1.339 1.888 1.8 1.04 4.763 1.04 6.583 0 0.91-0.519 1.369-1.204 1.377-1.888v-1e-3l-4.65-35.709z",
  fill: "#02665A"
});

var _ref27 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#FED322"
}, React.createElement("path", {
  d: "m248.03 14.015c0-7.084 5.338-12.916 12.21-13.708-0.939-0.198-1.913-0.307-2.913-0.307-7.74 0-14.015 6.275-14.015 14.015s6.275 14.015 14.015 14.015c1 0 1.973-0.109 2.913-0.307-6.872-0.792-12.21-6.623-12.21-13.708z"
}), React.createElement("polygon", {
  points: "257.56 1.523 263.12 9.278 272.21 6.384 266.56 14.07 272.12 21.826 263.06 18.821 257.4 26.508 257.46 16.965 248.4 13.96 257.5 11.066"
}));

var _ref28 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "255.97 324.06 255.97 344.95 473 219.65 473 198.77",
  fill: "#C6C5CB"
});

var SvgMosque = function SvgMosque(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMosque, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mosque.0c22104a.svg";
export { ForwardRef as ReactComponent };